import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/pwa-installs")({
  component: lazyRouteComponent(() => import("./-pages/admin.pwa-installs")),
  head: () => ({
    meta: [
      { title: "PWA Installs · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
